import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-info-white-circle',
  templateUrl: './icon-info-white-circle.component.html',
  styles: []
})
export class IconInfoWhiteCircleComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
